import { render, staticRenderFns } from "./SafetyCheckPartner444Index.vue?vue&type=template&id=1461b054&scoped=true"
import script from "./SafetyCheckPartner444Index.vue?vue&type=script&lang=js"
export * from "./SafetyCheckPartner444Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461b054",
  null
  
)

export default component.exports